import PromotionCodeEntry from './CodeEntry/CodeEntry.js';
import PromotionContest from './Contest/Contest.js';
import PromotionImageScanning from './ImageScanning/ImageScanning.js';
import PromotionReceiptScanning from './ReceiptScanning/ReceiptScanning.js';
import PromotionCodeEntryPotatoHunt from "./CodeEntryPotatoHunt/CodeEntryPotatoHunt";
import PromotionContestPotatoHunt from "./ContestPotatoHunt/PromotionContestPotatoHunt";
import PromotionCodeEntryEa from "./CodeEntryEa/PromotionCodeEntryEa";
import PromotionImageScanningPotatoHunt from "./ImageScanningPotatoHunt/PromotionImageScanningPotatoHunt";

function Promotion ({promotionSettings}) {

	return (
		<div className="pweu-promotion-wrapper">

            {promotionSettings.promotion_page.promotion_type === 'contest' || promotionSettings.promotion_page.promotion_type === 'lottery' ? <PromotionContest promotionSettings={promotionSettings}/> : null}
            {promotionSettings.promotion_page.promotion_type === 'code_entry' ? <PromotionCodeEntry promotionSettings={promotionSettings}/> : null}
            {promotionSettings.promotion_page.promotion_type === 'image_scanning' ? <PromotionImageScanning promotionSettings={promotionSettings}/> : null}
            {promotionSettings.promotion_page.promotion_type === 'receipt_scanning' ? <PromotionReceiptScanning promotionSettings={promotionSettings}/> : null}
            {promotionSettings.promotion_page.promotion_type === 'code_pep' ? <PromotionCodeEntryPotatoHunt promotionSettings={promotionSettings}/> : null}
			{promotionSettings.promotion_page.promotion_type === 'lottery_pep' ? <PromotionContestPotatoHunt promotionSettings={promotionSettings}/> : null}
            {promotionSettings.promotion_page.promotion_type === 'image_scanning_pep' ? <PromotionImageScanningPotatoHunt promotionSettings={promotionSettings}/> : null}
            {promotionSettings.promotion_page.promotion_type === 'code_entry_ea' ? <PromotionCodeEntryEa promotionSettings={promotionSettings}/> : null}

        </div>
    )
}

export default Promotion;

